<template>
    <div class="page">
      <div class="logo_zone"> 
        <img class="logo" :src="config.logo" alt="">
        <div class="desc">{{config.desc}}</div>
      </div>
      <div class="mobile_zone">
        <div class="mobile_tips">请完成手机号码验证</div>
        <div class="mobile_mobile_warp"><van-field v-model="mobile" label="" placeholder="请输入你的手机号码" /></div>
        <div class="mobile_password_warp">
            <van-password-input
              :value="code"
              :mask="false"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
            />
            <div class="mobile_op">
              <div class="mobile_op_text"  v-show="!showCountDown" @click="sendCode">获取验证码</div>
              <van-count-down :time="60000"
                            millisecond
                            ref="countDown"
                            @finish="finish"
                            v-show="showCountDown"
                            :auto-start="false">
                <template #default="timeData">
                    <span class="block">{{ timeData.seconds||60 }}s</span>
                </template>
            </van-count-down>
            </div>
        </div>
        <div v-if="0" class="mobile_comfirm_warp">
          <van-button round type="info" block>确认</van-button>
        </div>
        <div>
          <!-- 数字键盘 -->
            <van-number-keyboard
              v-model="code"
              :show="showKeyboard"
              @blur="showKeyboard = false"
            />
        </div>
      </div>
    </div>
</template>
<script>
import { Field,PasswordInput, NumberKeyboard,Button,CountDown } from 'vant';

export default {
  name: "mobile",
  components:{
    [Field.name]:Field,
    [PasswordInput.name]:PasswordInput,
    [NumberKeyboard.name]:NumberKeyboard,
    [Button.name]:Button,
    [CountDown.name]:CountDown,
  },
  watch:{
      code(value){
          var _self = this;
          if(value.length == 6){
              if(this.mobile == ''){
                  _self.code ='';
                  return this.util.showToast({
                      message:'手机号码不能为空'
                  })
              }
              if(!(/^1[3456789]\d{9}$/.test(this.mobile))){
                  _self.code ='';
                  return this.util.showToast({
                      message:'请输入正确的手机号码'
                  })
              }
              this.util.server.mini_user.h5_bind_phone({
                  data:{
                      mobile:this.mobile,
                      code:value
                  },
                  callback: (res =>{
                      const {code,data,msg} = res;
                      if(code == -1){
                          _self.code ='';
                          return false;
                      }

                      _self.util.user_mobile.set(this.mobile);

                      setTimeout(function(){
                        if(_self.util.tempRedirect.get(location.href)){
                          window.location = _self.util.tempRedirect.get(location.href)
                        }else{
                          _self.$router.replace(_self.util.urlPrefix+'/home/index?'+'&token='+_self.util.token)
                        }
                      },300)
                  })

              })
          }
      }
  },
  data(){
    return {
      mobile:'',
      showKeyboard: false,
      showCountDown:false,
      code:'',
      config:''
    }
  },
  mounted(){
    this.config = this.util.G_CONFIG
  },
  methods:{
    finish(){
        this.showCountDown=false;
        this.$refs.countDown.reset();
    },
    sendCode(){
        if(!(/^1[3456789]\d{9}$/.test(this.mobile))){
            return this.util.showToast({
                message:'请输入正确的手机号码'
            })
        }
        const _self = this
        // 验证是否有双账号问题
        this.util.server.mini_user.check_mobile_bind({
            data:{
                mobile:this.mobile
            },
            callback:(res =>{
                const {code,data,msg} = res;
                if(code == -1){
                    return
                }
                if(data.status==2){ 
                  // 当前用户已经绑定了其他用户，跳转合并账号,并设置需要返回的路径
                  _self.util.tempRedirect.set(location.href)
                  _self.$router.push(this.util.urlPrefix+'/user/merge?mobile='+_self.mobile+'&token='+this.util.token)
                  return
                }else if(data.status==1){
                  _self.util.showToast({
                      message:'您的手机号码已经绑定,正为您更新'
                  })
                  _self.util.user_mobile.set(_self.mobile);

                  setTimeout(function(){
                    if(_self.util.tempRedirect.get(location.href)){
                      window.location = _self.util.tempRedirect.get(location.href)
                    }else{
                      _self.$router.replace(_self.util.urlPrefix+'/home/index?'+'&token='+_self.util.token)
                    }
                  })
                  
                  return 
                }else{
                  _self.sendLoginCode()
                }
            })
        })

        
    },
    sendLoginCode(){
        this.util.server.user.login_code({
            data:{
                mobile:this.mobile
            },
            callback:(res =>{
                const {code,data,msg} = res;
                if(code == -1){
                    return
                }

                this.code='';
                this.showKeyboard=true;
                this.showCountDown=true;
                this.$refs.countDown.start();
            })
        })
    }
  }

}
</script>
<style  scoped>
.page{
  margin: auto 0;
}
.logo_zone{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo{
  margin-top: 45px;
  width: auto;
  height: 50px;
  margin-left: auto;
  margin-right: auto;
}
.desc{
  margin-top: 10px;
  color: rgb(104, 100, 100);
  font-weight: 600;
}
.mobile_zone{
  margin-top: 40px;
  margin-left: auto;
  margin-right: auto;
  width: 320px;
}
.mobile_tips{
  font-size: 12px;
  
  color: #777272;
}
.mobile_mobile_warp{
  margin-top: 15px;
}
.mobile_password_warp{
  margin-top: 15px;
}
.mobile_comfirm_warp{
  margin-top: 30px;
}
.mobile_password_warp{
  display: flex;
  align-items: center;
}
.mobile_op{
  width: 65px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background-color: coral;
  color: #FFF;
  border-radius: 20px;
}
.mobile_op_text{
  font-size: 11px;
}
.mobile_password_warp .van-password-input{
  margin-left: 0;
  flex: 1;
}
.mobile_mobile_warp >>> .van-field__control{
  letter-spacing: 10px;
}
.mobile_op >>> .van-count-down{
  color: #FFF;
  height: 32px;
  line-height: 32px;
}
</style>